import { BadgeConfig, StatusBadgeType } from './types';

type TranslateFn = (key: string) => string;

export function getBadgeConfig(
    type: StatusBadgeType,
    valStr: string,
    t: TranslateFn,
    label?: string
): BadgeConfig | null {
    const strategies: Record<StatusBadgeType, () => BadgeConfig | null> = {
        gender: () => {
            const isFemale = ['k', 'f', 'female', 'kadın', 'kadin'].includes(valStr);
            const isMale = ['e', 'm', 'male', 'erkek'].includes(valStr);

            if (isFemale) {
                return {
                    label: label || t('female'),
                    color: '#e91e63',
                    bgColor: '#fdf2f8',
                    dotColor: '#ec4899',
                };
            }
            if (isMale) {
                return {
                    label: label || t('male'),
                    color: '#0288d1',
                    bgColor: '#f0f9ff',
                    dotColor: '#0ea5e9',
                };
            }
            return null;
        },
        surgery: () => {

            const isInService = ['serviste', '1'].includes(valStr);
            const isInSurgery = ['ameliyatta', 'ameliy.', '2'].includes(valStr);

            if (isInService) {
                return {
                    label: label || t('nurse.surgery-status.in-service'),
                    color: '#1976d2',
                    bgColor: '#eff6ff',
                    dotColor: '#2563eb',
                };
            }
            if (isInSurgery) {
                return {
                    label: label || t('nurse.surgery-status.in-surgery'),
                    color: '#854d0e',
                    bgColor: '#fefce8',
                    dotColor: '#a16207',
                };
            }
            return null;
        },
    };

    const strategy = strategies[type];
    const result = (strategy && strategy());

    if (result) {
        return result;
    }

    const finalLabel = label || valStr;
    if (!finalLabel) {
        return null;
    }

    return {
        label: finalLabel,
        color: '#637381',
        bgColor: '#f4f6f8',
        dotColor: '#919eab',
    };
}
